import HappyRobotSvg from '@/assets/HappyRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { FinalMessageProps } from '@/views/process/components/skillsAssessmentCollectedPage/FinalMessageDesktop.tsx';
import React from 'react';

const FinalMessageMobile: React.FC<FinalMessageProps> = ({ handleFinish, processInfo }) => {
  const { t } = useTranslationWithPrefix('skillsAssessmentCollectedPage');
  return (
    <div className="flex flex-column">
      <DialogMobile
        content={
          <>
            <span className="text-primary">{t('subMessage1')}</span>
            {t('subMessage2')}
            <a
              className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
              href={processInfo?.recruitmentUrl}
            >
              {t('here')}
            </a>
            .
            <p className="pt-2">
              {t('subMessage3')}
              <span className="text-primary"> {t('subMessage4')}</span>
              {t('subMessage5', { contactEmail: processInfo?.contactEmail })}
            </p>
            <p>{t('subMessage6')}</p>
          </>
        }
        image={
          <img
            alt="end-robot"
            className="object-cover w-full"
            src={generateNonCachableImageSrc(HappyRobotSvg)}
          />
        }
        message={t('heading')}
      />
      <ButtonWithLoading onClick={handleFinish}>{t('buttons.finish')}</ButtonWithLoading>
    </div>
  );
};

export default FinalMessageMobile;
